export enum ProgressName {
  BASIC = 'Basic',
  ADVANCED = 'Advanced',
  PRO = 'Pro',
  MENTOR = 'Mentor',
}
